import React, { useCallback, useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';

import Step1Collection from './Step1Collection';
import Step2Collection from './Step2Collection';
import Step3Collection from './Step3Collection';
import Step4Collection from './Step4Collection';
import Step5Collection from './Step5Collection';
import Step6Collection from './Step6Collection';
import Step7Collection from './Step7Collection';

import Utils from '../../utils/utils';
import i18n from '../../i18n';
import Icons from '../../utils/Icons';
import ProgressBar from '../signup-funnel/ProgressBar';
import Api from '../../api/Api';

const HeaderSignupCollection = () => {
    const [currentStep, setCurrentStep] = useState(0);
    const [localUser, setLocalUser] = useState('');

    const steps = ['step1', 'step2', 'step3', 'step4', 'step5', 'step6', 'step7'];

    const handleExit = useCallback(() => {
        sweetAlert({
            content: (
                <div className="collection-popup">
                    <div className="collection-popup-header">
                        {/* eslint-disable-next-line react/jsx-no-bind */}
                        <div
                            className="icon-collection-close"
                            onClick={() => {
                                sweetAlert.close();
                            }}
                        >
                            {Icons.transform(2)}
                        </div>
                    </div>
                    <div className="collection-popup-content">
                        <h4 className="collection-popup-title">
                            {i18n.t('collection:confirm_cancel_signup_flow_collection_title')}
                        </h4>
                        <p
                            className="collection-popup-text"
                            dangerouslySetInnerHTML={{
                                __html: i18n.t('collection:confirm_cancel_signup_flow_collection_text')
                            }}
                        />
                    </div>
                </div>
            ),
            closeOnClickOutside: true,
            buttons: [i18n.t('common:continue'), i18n.t('common:exit')],
            className: 'collection-popup-modal'
        }).then((isConfirm) => {
            if (isConfirm) {
                Api.User.signupCollectionFlowAbandonned()
                    .then(() => {
                        document.location.href = `${i18n.t('url:logout.url')}-collection`;
                    })
                    .catch((e) => {
                        console.error(e);
                        document.location.href = `${i18n.t('url:logout.url')}-collection`;
                    });
            }
        });
    }, []);

    useEffect(() => {
        const local = ['fr', 'en', 'it'];
        if (local.indexOf(document.documentElement.lang) <= 0) {
            setLocalUser(`/${document.documentElement.lang}`);
        }
    });

    useEffect(() => {
        // take the last element of the pathname
        const lastElementPathname = window.location.pathname.split('/').slice(-1)[0];
        if (steps.indexOf(lastElementPathname) > -1) {
            const numberStep = parseInt(lastElementPathname.match(/\d+/)[0], 10);
            setCurrentStep(numberStep);
        } else {
            setCurrentStep(0);
        }
    });

    return (
        <>
            <div className="header-signup-collection">
                <div className="header-signup-buttons">
                    <a onClick={handleExit}>
                        <img
                            src={`${Utils.getCloudfrontDomain()}/images/website/logo/he-logo-collections.svg`}
                            alt="header_landing_page"
                        />
                    </a>
                    {document.location.pathname !== `${localUser}/collection/propose-my-home` && (
                        <button className="btn btn-exit" onClick={handleExit}>
                            {i18n.t('common:exit')}
                        </button>
                    )}
                </div>
                {currentStep > 0 && <ProgressBar currentStep={currentStep} totalSteps={7} />}
            </div>

            <Routes>
                <Route path="step1" element={<Step1Collection />} />
                <Route path="step2" element={<Step2Collection />} />
                <Route path="step3" element={<Step3Collection />} />
                <Route path="step4" element={<Step4Collection />} />
                <Route path="step5" element={<Step5Collection />} />
                <Route path="step6" element={<Step6Collection />} />
                <Route path="step7" element={<Step7Collection />} />
            </Routes>
        </>
    );
};

export default HeaderSignupCollection;
